import { MyBrandTagType } from '@wconcept/wconcept-common/models/renewal/discovery';
import {
  IconBookMark01,
  IconHeart05,
  IconCart03,
} from '@wconcept/wconcept-ui-renewal/components/atoms/svg';
import * as S from './style';

interface IProps {
  sectionText?: string;
  prsnlTagText?: string;
  liveType?: 'onair' | 'ready' | 'ended' | string;
  prsnlType?: MyBrandTagType;
}

const PrsnlTag = ({
  sectionText,
  prsnlType,
  liveType,
  prsnlTagText,
}: IProps) => {
  const getPrsnl = () => {
    if (prsnlTagText) {
      return (
        <span>
          <span className="icon">
            <IconBookMark01 />
          </span>
          {prsnlTagText}
        </span>
      );
    }
    return null;
  };

  const getLive = () => {
    if (liveType === 'onair') {
      return <span className="point onair">라이브 진행중</span>;
    }
    if (liveType === 'ready') {
      return <span className="point">라이브 예정</span>;
    }
    if (liveType === 'ended') {
      return <span className="point">라이브 종료</span>;
    }
    return null;
  };

  return (
    <S.PrsnlTag className="prsnl-tag" prsnlType={prsnlType} liveType={liveType}>
      {sectionText && <span className="point">{sectionText}</span>}
      {liveType && getLive()}
      {prsnlType && getPrsnl()}
    </S.PrsnlTag>
  );
};

export default PrsnlTag;
